module.exports = __webpack_public_path__ + "static/media/AlsaceIvory.f643957f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fabrics/AlsaceIvory.jpg
// module id = 26
// module chunks = 0